var blockquote_default = {
  "fontElementMap": "vfqy1",
  "quote": "BpJjy"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
